import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function ClassifiersAPI() {
    const baseClassifiersAPI = "classifiers";

    async function listClassifiers(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${API_VERSIONS.v1}/${baseClassifiersAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function createClassifier(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseClassifiersAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateClassifier(payload) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseClassifiersAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteClassifer(classifierId) {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${baseClassifiersAPI}/${classifierId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listClassifiers,
        createClassifier,
        updateClassifier,
        deleteClassifer,
    };
}
export default ClassifiersAPI();
